import { api } from "@/utils/axios";

export const repairService = {
  my_shop_lists(body: any) {
    return api.post(
      "https://wy-app.dong-park.com/?c=Port&from=dong-park&m=actionGet_Web_v2_Port&module=User&opt=my_shop_lists",
      body
    );
  },
  searchFaultType(body: any) {
    return api.post("/Mydb/faulttype_lists", body);
  },
  // 报单
  addFault(body: any) {
    return api.post("/Repair/add_fault", body);
  },
  getFaultType(body: any) {
    return api.post("/Mydb/faulttype_type_lists", body);
  },
  // 位置树
  placeTree(body: any) {
    return api.post("/Mydb/place_lists", body);
  },
  // 工单列表
  repairList(body: any) {
    return api.post("/Repair/repair_lists", body);
  },
  // 专业列表
  getSubgroupList() {
    return api.post("/Transfer/index?c=Mydb&m=subgroup_lists");
  },
  // 工单详情
  repair_con(body: any) {
    return api.post("/Repair/repair_con", body);
  },
  // 接单
  acceptWorkOrder(body: any) {
    return api.post("/Transfer/index?c=Repair&m=accept_workorder", body);
  },
  // 取消
  closeWorkOrder(body: any) {
    return api.post("/Transfer/index?c=Repair&m=close_workorder", body);
  },
  // 获取按钮
  handle_button(body: any) {
    return api.post("/Repair/handle_button", body);
  },
  // 到达现场
  startRepair(body: any) {
    return api.post("/Transfer/index?c=Repair&m=start_repair", body);
  },
  // 选择原因
  getReason() {
    return api.post("/Transfer/index?c=Hqdb&m=get_param_detail", {
      type: "collection",
      is_all: 1
    });
  },
  // 工单确认用户列表
  workOrderConfirmUsers(body: any) {
    return api.post("/Transfer/index?c=Repair&m=workorder_confirm_users", body);
  },
  // ,处理维修过程
  addProcessed(body: any) {
    return api.post("/Transfer/index?c=Repair&m=add_processed", body);
  },
  // 工单派工
  dispatchWorkOrder(body: any) {
    return api.post("/Transfer/index?c=Repair&m=dispatch_workorder", body);
  },
  // 用户确认工单
  faultConfirm(body: any) {
    return api.post("/Repair/fault_confirm", body);
  },
  // 重启工单的接口
  workorderRestart(body: any) {
    return api.post("/Transfer/index?c=Repair&m=workorder_restart", body);
  },
  // 评价
  addPraise(body: any) {
    return api.post("/Transfer/index?c=Repair&m=add_praise", body);
  },
  // 挂单
  workorderPauseVerify(body: any) {
    return api.post("/Transfer/index?c=Repair&m=workorder_pause_verify", body);
  },
  // 日志
  workorderLogs(body: any) {
    return api.post("/Transfer/index?c=Repair&m=workorder_logs", body);
  },
  // 日志
  maintainPlanLists(body: any) {
    return api.post("/Transfer/index?c=Repair&m=maintain_plan_lists", body);
  },
  maintainPlanDetail(body: any) {
    return api.post("/Transfer/index?c=Repair&m=maintain_plan_detail", body);
  },
  // 接收指派给我的工单
  acceptDispatchWorkorderNew(body: any) {
    return api.post("/Transfer/index?c=Repair&m=accept_dispatch_workorder_new", body);
  },
  // 接收指派给我的工单
  rejectDispatchWorkorder(body: any) {
    return api.post("/Transfer/index?c=Repair&m=reject_dispatch_workorder", body);
  },
  // 关联客户详情
  storesDetail(body: any) {
    return api.post("/Transfer/index?c=Factory&m=stores_detail", body);
  },
  saveImg(data: any) {
    return api.post("/Mydb/save_img", data);
  },
  repair_config_detail(data: any) {
    return api.post("/Backstage/repair_config_detail", data);
  }
};
